import React from 'react';
import * as Icons from 'lucide-react';
import { solutions } from '../mock';

const borderColors = [
  '#1F8B4C', // green
  '#FF7A00', // orange
  '#FFB629', // yellow
  '#146638', // dark green
  '#FF9F42', // light orange
  '#26A45A', // mid green
];

export default function Solutions() {
  return (
    <section className="section bg-[color:var(--brand-green-light)]/40">
      <div className="container-x">
        <div className="text-center mb-14">
          <div className="eyebrow">What we do</div>
          <h2 className="section-title mt-3">Solutions That Drive Success</h2>
          <p className="section-sub mt-4 mx-auto">
            Strategy-driven services that put your brand in front of the right customers on every
            platform that matters.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {solutions.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            const bc = borderColors[i % borderColors.length];
            return (
              <div
                key={s.title}
                className="card-hover bg-white rounded-2xl p-7 shadow-sm relative overflow-hidden"
                style={{
                  border: `2px solid ${bc}30`,
                  boxShadow: `0 4px 20px -8px ${bc}25`,
                }}
              >
                <div
                  className="absolute top-0 left-0 h-full w-1"
                  style={{ background: bc }}
                />
                <div
                  className="absolute -right-8 -top-8 w-24 h-24 rounded-full opacity-10"
                  style={{ background: bc }}
                />
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5"
                  style={{ background: `${bc}18`, color: bc }}
                >
                  <Icon size={26} />
                </div>
                <h3 className="font-bold text-[color:var(--ink)] text-lg mb-2">{s.title}</h3>
                <p className="text-sm leading-relaxed text-[color:var(--ink-soft)]">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
